<div class="card m-3 project-add-card">
  <div class="card-body">

    <div class="grid-header">
      <h2 class="grid-title">
        <mat-icon class="title-icon">add_circle</mat-icon>
        New Project
      </h2>
      <a routerLink="/projects" class="back-link">
        <mat-icon>arrow_back</mat-icon> Back to Projects
      </a>
    </div>

    <p class="form-subtitle">
      Give your project a name and description to get started — you can add materials,
      contractors, and a schedule once it's created.
    </p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="project-add-form">

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Project Title</mat-label>
        <input matInput formControlName="title" placeholder="e.g. Kitchen Remodel" maxlength="100">
        <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required</mat-error>
      </mat-form-field>

      <div class="field-group">
        <label class="field-label">Priority</label>
        <div class="priority-chip-row">
          <button type="button" *ngFor="let p of priorityOptions"
                  class="priority-chip priority-chip-{{ p.value }}"
                  [class.selected]="form.value.priority === p.value"
                  (click)="selectPriority(p.value)">
            {{ p.label }}
          </button>
        </div>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Project Description</mat-label>
        <textarea matInput formControlName="projectDescription" rows="5"
                  placeholder="Describe the scope of work…" maxlength="1000"></textarea>
        <mat-hint align="end">{{ descriptionLength }}/1000</mat-hint>
        <mat-error *ngIf="form.get('projectDescription')?.hasError('required')">Description is required</mat-error>
      </mat-form-field>

      <div class="form-actions">
        <button type="button" mat-stroked-button (click)="cancel()" [disabled]="isSubmitting">Cancel</button>
        <button type="submit" mat-raised-button color="primary" [disabled]="isSubmitting">
          <mat-icon *ngIf="!isSubmitting">add</mat-icon>
          <span *ngIf="!isSubmitting">Create Project</span>
          <span *ngIf="isSubmitting">Creating…</span>
        </button>
      </div>

    </form>

  </div>
</div>
